import { createRootRoute, Link, Outlet } from "@tanstack/react-router";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";
import { useAuthSync } from "@/hooks/use-auth";
import { useGlobalSSE } from "@/hooks/use-sse";

function GlobalSSEListener() {
  useGlobalSSE();
  return null;
}

function AuthSync() {
  useAuthSync();
  return null;
}

export const Route = createRootRoute({
  component: () => (
    <>
      <AuthSync />
      <GlobalSSEListener />
      <Outlet />
      <TanStackRouterDevtools />
    </>
  ),
  errorComponent: ({ error }) => (
    <div style={{ padding: 24 }}>
      <h1 style={{ fontSize: 24, marginBottom: 12 }}>Something went wrong</h1>
      <p style={{ color: "#555" }}>{error?.message ?? "Unexpected error"}</p>
      <div style={{ marginTop: 16 }}>
        <Link to="/">Go home</Link>
      </div>
    </div>
  ),
});
